// mutations
const PAPELERIA_PRODUCTS_CATEGORIES_ALL = (state, papeleriaProductsCategories) => {
  if (papeleriaProductsCategories.code === 1) {
    state.papeleriaProductsCategories = papeleriaProductsCategories.data
    state.status = 'success'
  } else {
    alert(papeleriaProductsCategories.message)
    state.status = 'error'
  }
}

const PAPELERIA_PRODUCTS_CATEGORIES_FORM = (state, papeleriaProductsCategories) => {
  if (papeleriaProductsCategories.code === 1) {
    state.papeleriaProductsCategories = papeleriaProductsCategories.data
    state.status = 'success'
  } else {
    alert(papeleriaProductsCategories.message)
    state.status = 'error'
  }
}

const PAPELERIA_PRODUCTS_CATEGORIES_SHOW = (state, papeleriaProductsCategories) => {
  if (papeleriaProductsCategories.code === 1) {
    state.papeleriaProductsCategories = papeleriaProductsCategories.data
    state.status = 'success'
  } else {
    alert(papeleriaProductsCategories.message)
    state.status = 'error'
  }
}

const PAPELERIA_PRODUCTS_CATEGORIES_CREATE = (state, papeleriaProductsCategories) => {
  if (papeleriaProductsCategories.code === 1) {
    state.papeleriaProductsCategories = papeleriaProductsCategories.data
    state.status = 'success'
    alert(papeleriaProductsCategories.message)
  } else {
    alert(papeleriaProductsCategories.message)
    state.status = 'error'
  }
}

const PAPELERIA_PRODUCTS_CATEGORIES_UPDATE = (state, papeleriaProductsCategories) => {
  if (papeleriaProductsCategories.code === 1) {
    state.papeleriaProductsCategories = papeleriaProductsCategories.data
    state.status = 'success'
    alert(papeleriaProductsCategories.message)
  } else {
    alert(papeleriaProductsCategories.message)
    state.status = 'error'
  }
}

const PAPELERIA_PRODUCTS_CATEGORIES_DELETE = (state, papeleriaProductsCategories) => {
  if (papeleriaProductsCategories.code === 1) {
    state.papeleriaProductsCategories = papeleriaProductsCategories.data
    state.status = 'success'
    alert(papeleriaProductsCategories.message)
  } else {
    alert(papeleriaProductsCategories.message)
    state.status = 'error'
  }
}

export default {
  PAPELERIA_PRODUCTS_CATEGORIES_ALL,
  PAPELERIA_PRODUCTS_CATEGORIES_FORM,
  PAPELERIA_PRODUCTS_CATEGORIES_SHOW,
  PAPELERIA_PRODUCTS_CATEGORIES_CREATE,
  PAPELERIA_PRODUCTS_CATEGORIES_UPDATE,
  PAPELERIA_PRODUCTS_CATEGORIES_DELETE
}



// WEBPACK FOOTER //
// ./src/store/modules/papeleria/products/categories/mutations.js